import { useTheme } from "@material-ui/core/styles"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function InitialTabButton({
    onClick,
    onHover = () => { },
    enabled = true,
    backgroundColor,
    cursor,
    imageSrc,
    tabIndex = -1,
    accKey,
    title,
    Icon,
    iconStyle,
    header,
    text
}) {
    const {
        theme: { colors },
    } = useTheme()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    const isContrast = themeState !== config.THEMES_MODES.LIGHT

    const mergedIconStyle = {
        position: 'absolute',
        top: -2,
        right: 0,
        fontSize: 24,
        color: isContrast && enabled ? colors.colorContrast : colors.colorMutedText,
        borderRadius: '50%',
        padding: 2,
        ...iconStyle,
    }

    return (
        // eslint-disable-next-line jsx-a11y/no-access-key
        <div
            style={{
                backgroundColor,
                borderRadius: 10,
                padding: '10px 12px',
                cursor,
                overflow: 'hidden',
            }}
            onClick={enabled ? onClick : undefined}
            tabIndex={tabIndex}
            onMouseEnter={() => enabled && onHover(true)}
            onMouseLeave={() => enabled && onHover(false)}
            accessKey={accKey}
            title={title}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <p style={{ textAlign: 'center', fontWeight: 'bold', color: enabled ? colors.colorText : colors.colorMutedText, margin: '0 0 6px 0' }}>
                        {header}
                    </p>
                    <p
                        dangerouslySetInnerHTML={{ __html: text }}
                        style={{
                            fontFamily: 'sans-serif',
                            color: enabled ? colors.colorText : colors.colorMutedText,
                            margin: 0,
                            fontSize: '0.9rem',
                        }}
                    />
                </div>
                <div
                    style={{
                        position: 'relative',
                        width: '96px',
                        height: '64px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    <img
                        src={imageSrc}
                        alt="ComLab AI Bot"
                        width="96px"
                        height="64px"
                        style={{ display: 'block' }}
                    />
                    {Icon ? <Icon style={mergedIconStyle} /> : null}
                </div>
            </div>
        </div>
    )
}
